<div class="list-panel-container">
  <div class="row space-between">
    <div style="max-width: 98%">
      <h3 style ="font-weight: normal">Global</h3>
    </div>
    <div style="max-width: 2%" (click)="togglePanel('global')">
      <mat-icon>{{expandedPanels['global'] ? 'arrow_drop_up' : 'arrow_drop_down'}}</mat-icon>
    </div>
  </div>
  <mat-divider></mat-divider>
  @if(expandedPanels['global']){
    @for(pipeline of globalViews; track $index){
      <div class="row pipeline-tile">
        <div class="col-md-2">
          <div>{{pipeline.name}}</div>
        </div>
        <div class="col-md-2">
          Last Modified on {{pipeline.modified | date: 'MM/dd/yyyy hh:mm a'}}
        </div>
        <div class="col-md-2">
          --
        </div>
        <div class="col-md-2">
          --
        </div>
        <div class="col-md-4">
          <mat-button-toggle-group class="small-toggle">
            <mat-button-toggle (click)="viewRedirect(pipeline)">VIEW</mat-button-toggle>
            <mat-button-toggle (click)="openEditModal(pipeline)">SAVE AS</mat-button-toggle>
            <mat-button-toggle (click)="openExportModal(pipeline)" [disabled]="!fields">EXPORT</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    }

  }
  <div class="row space-between">
    <div style="max-width: 98%">
      <h3 style="font-weight: normal">Pipeline Reports</h3>
    </div>
    <div style="max-width: 2%" (click)="togglePanel('report')">
      <mat-icon>{{expandedPanels['report'] ? 'arrow_drop_up' : 'arrow_drop_down'}}</mat-icon>
    </div>
  </div>
  <mat-divider></mat-divider>
  @if(expandedPanels['report']){
    @for(pipeline of pipelineReports; track $index){
      <div class="row pipeline-tile">
        <div class="col-md-2">
          <div>{{pipeline['name']}}</div>
        </div>
        <div class="col-md-2">
          --
        </div>
        <div class="col-md-2">
          --
        </div>
        <div class="col-md-2">
          --
        </div>
        <div class="col-md-4">
          <mat-button-toggle-group class="small-toggle">
            <mat-button-toggle (click)="viewRedirect(pipeline)">VIEW</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    }
  }
  <div class="row space-between">
    <div style="max-width: 98%">
      <h3 style="font-weight: normal">Owned</h3>
    </div>
    <div style="max-width: 2%" (click)="togglePanel('owned')">
      <mat-icon>{{expandedPanels['owned'] ? 'arrow_drop_up' : 'arrow_drop_down'}}</mat-icon>
    </div>
  </div>
  <mat-divider></mat-divider>
  @if(expandedPanels['owned']){
    @for(pipeline of ownedViews; track $index){
      <div class="row pipeline-tile">
        <div class="col-md-2">
          <div>{{pipeline.name}}</div>
        </div>
        <div class="col-md-2">
          Last Modified on {{pipeline.modified | date: 'MM/dd/yyyy hh:mm a'}}
        </div>
        <div class="col-md-2">
          Owned by {{pipeline.relatedGroup ? pipeline.relatedGroup.name : pipeline.person.name}}
        </div>
        <div class="col-md-2">
          @if(sharedMap.get(pipeline.id) && sharedMap.get(pipeline.id)!==""){
            Shared with {{sharedMap.get(pipeline.id)}}
          } @else {
            --
          }
        </div>
        <div class="col-md-4">
          <mat-button-toggle-group class="small-toggle">
            <mat-button-toggle (click)="viewRedirect(pipeline)">VIEW</mat-button-toggle>
            <mat-button-toggle (click)="openShareModal(pipeline)">SHARE</mat-button-toggle>
            <mat-button-toggle (click)="openEditModal(pipeline)">EDIT</mat-button-toggle>
            <mat-button-toggle (click)="openExportModal(pipeline)">EXPORT</mat-button-toggle>
            <mat-button-toggle (click)="removePipeline(pipeline)">REMOVE</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    }
  }
  <div class="row space-between">
    <div style="max-width: 98%">
      <h3 style ="font-weight: normal">Shared</h3>
    </div>
    <div style="max-width: 2%" (click)="togglePanel('shared')">
      <mat-icon>{{expandedPanels['shared'] ? 'arrow_drop_up' : 'arrow_drop_down'}}</mat-icon>
    </div>
  </div>
  <mat-divider></mat-divider>
  @if(expandedPanels['shared']){
    @for(pipeline of sharedViews; track $index){
      <div class="row pipeline-tile">
        <div class="col-md-2">
          <div>{{pipeline.pipeline.name}}</div>
        </div>
        <div class="col-md-2">
          Last Modified on {{pipeline.pipeline.modified | date: 'MM/dd/yyyy hh:mm a'}}
        </div>
        <div class="col-md-2">
          Owned by {{pipeline.pipeline.relatedGroup ? pipeline.pipeline.relatedGroup.name : pipeline.pipeline.person.name}}
        </div>
        <div class="col-md-2">
          @if(sharedMap.get(pipeline.pipeline.id) && sharedMap.get(pipeline.pipeline.id)!==""){
            Shared with {{sharedMap.get(pipeline.pipeline.id)}}
          } @else {
            --
          }
        </div>
        <div class="col-md-4">
          <mat-button-toggle-group class="small-toggle">
            <mat-button-toggle (click)="viewRedirect(pipeline.pipeline)">VIEW</mat-button-toggle>
<!--            <mat-button-toggle (click)="openShareModal(pipeline.pipeline)">SHARE</mat-button-toggle>-->
            <mat-button-toggle (click)="openEditModal(pipeline.pipeline)" [disabled]="!pipeline._edit">EDIT</mat-button-toggle>
            <mat-button-toggle (click)="openExportModal(pipeline.pipeline)">EXPORT</mat-button-toggle>
            <mat-button-toggle [disabled]="!pipeline._delete" (click)="removePipeline(pipeline.pipeline)">REMOVE</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    }
  }
  <div class="row space-between">
    <div style="max-width: 98%">
      <h3 style ="font-weight: normal">Investor</h3>
    </div>
    <div style="max-width: 2%" (click)="togglePanel('investor')">
      <mat-icon>{{expandedPanels['investor'] ? 'arrow_drop_up' : 'arrow_drop_down'}}</mat-icon>
    </div>
  </div>
  <mat-divider></mat-divider>
  @if(expandedPanels['investor']){
    @for(pipeline of investorView; track $index){
      <div class="row pipeline-tile">
        <div class="col-md-2">
          <div>
            @if(pipeline.pipeline.associatedOrganization){
              {{pipeline.pipeline.associatedOrganization.name ?? pipeline.pipeline.name}}
            }
            @if(pipeline.pipeline.associatedSponsor){
              {{pipeline.pipeline.associatedSponsor.name ?? pipeline.pipeline.name}}
            }
          </div>
        </div>
        <div class="col-md-2">{{pipeline.pipeline.name}}</div>
        <div class="col-md-2">
          Last Modified on {{pipeline.pipeline.modified | date: 'MM/dd/yyyy hh:mm a'}}
        </div>
        <div class="col-md-2">
          Owned by {{pipeline.pipeline.relatedGroup ? pipeline.pipeline.relatedGroup.name : pipeline.pipeline.person.name}}
        </div>
        <div class="col-md-2">
          @if(sharedMap.get(pipeline.pipeline.id) && sharedMap.get(pipeline.pipeline.id)!==""){
            Shared with {{sharedMap.get(pipeline.pipeline.id)}}
          } @else {
            --
          }
        </div>
        <div class="col-md-2">
          <mat-button-toggle-group class="small-toggle">
            <mat-button-toggle (click)="viewRedirect(pipeline.pipeline)">VIEW</mat-button-toggle>
            <!--            <mat-button-toggle (click)="openShareModal(pipeline.pipeline)">SHARE</mat-button-toggle>-->
            <mat-button-toggle (click)="openEditModal(pipeline.pipeline)" [disabled]="!pipeline._edit">EDIT</mat-button-toggle>
            <mat-button-toggle (click)="openExportModal(pipeline.pipeline)">EXPORT</mat-button-toggle>
            <mat-button-toggle [disabled]="!pipeline._delete" (click)="removePipeline(pipeline.pipeline)">REMOVE</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    }
  }
</div>
